import Vue from 'vue';
import Vuex from 'vuex';

import globalNotes from './modules/globalNotes';
import substances from './modules/substances';
import preparations from './modules/preparations';
import routeOfAdministration from './modules/routeOfAdministration';
import wada from './modules/wada';
import icons from './modules/icons';
import auth from './modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        globalnotes: globalNotes,
        routeofadministration: routeOfAdministration,
        substances,
        wada,
        icons,
        preparations,
    },
});
